import api from "@/api/orderType";
import { errorHandler } from "../exports/error_management";

import { StorageCache } from "../exports/dataStorage";

const storageKey = "ams-order-type-key";

const state = {
  item: null,
  items: [],
};

const getters = {
  activityTypesByPermission: (state, getters, rootState) => {
    const onlyUnique = (value, index, array) => array.indexOf(value) === index;

    const permittedTypeIds = rootState.activity_type_permissions.filter(
      onlyUnique
    );
    console.log("not unique:", rootState.activity_type_permissions);
    console.log("unique permittedTypeIds:", permittedTypeIds);
    console.log("all orderTypes:", state.items);
    if (!state.items || !state.items.length) return [];

    const permittedTypes = state.items.filter((x) =>
      permittedTypeIds.some((permittedId) => permittedId === x.id)
    );

    const unPermittedTypes = state.items.filter(
      (x) => !permittedTypeIds.some((permittedId) => permittedId === x.id)
    );

    permittedTypes.sort((a, b) => {
      let fa = a.name.toLowerCase(),
        fb = b.name.toLowerCase();
      if (fa < fb) {
        return -1;
      }
      if (fa > fb) {
        return 1;
      }
      return 0;
    });

    console.log("permittedTypes:", permittedTypes);
    console.log("unPermittedTypes:", unPermittedTypes);

    return permittedTypes;
  },
};

const mutations = {
  set_item(state, payload) {
    state.item = payload;
  },
  set_items(state, payload) {
    state.items = payload;
  },
};

const actions = {
  async create(context, payload) {
    const storageCache = new StorageCache(storageKey);
    try {
      storageCache.reset();
      await api.create(payload);
      // context.dispatch("fetchAll");
    } catch (err) {
      errorHandler(err);
    }
  },
  async fetchById(context, id) {
    try {
      id = parseInt(id);
      if (!id) {
        context.commit("set_item", null);
        return;
      }
      const {
        data: {
          success: { data },
        },
      } = await api.fetchById(id);

      console.log("fetch item", data);
      context.commit("set_item", data);
    } catch (err) {
      errorHandler(err);
    }
  },

  async fetchAll(context) {
    const storageCache = new StorageCache(storageKey);
    try {
      const { is_valid, value } = storageCache.getArray();
      if (!is_valid) {
        const {
          data: {
            success: { data },
          },
        } = await api.fetchAll();
        storageCache.set(data);
        console.log("orderType fetchall", data);
        value.length = 0;
        value.push(...data);
      }
      context.commit("set_items", value);
    } catch (err) {
      errorHandler(err);
    }
  },

  async customerFetchAll(context) {
    try {
      const {
        data: {
          success: { data },
        },
      } = await api.fetchAll();
      context.commit("set_items", data);
    } catch (err) {
      errorHandler(err);
    }
  },

  async update(context, payload) {
    const storageCache = new StorageCache(storageKey);
    try {
      console.log("update", payload);
      storageCache.reset();
      await api.update(payload.id, payload);
      // context.dispatch("fetchAll");
    } catch (err) {
      errorHandler(err);
    }
  },

  async delete(context, id) {
    const storageCache = new StorageCache(storageKey);
    try {
      storageCache.reset();
      await api.delete(id);
      // context.dispatch("fetchAll");
    } catch (err) {
      errorHandler(err);
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
